import React from 'react';
import { SkeletonLoader } from '@/components/Loaders';
import { scoreDisplayStyles } from '../Scorecard.styles';
import { AnimatedScore } from './ScorecardAnimatedScore';
import { FormattedScore } from './ScorecardFormattedScore';

export interface ScoreDisplaySectionProps {
	isLoading?: boolean;
	isPrinting?: boolean;
	maxScore: number;
	score?: number;
	scoreSize: 'compact' | 'standard' | 'large';
	useAnimatedNumbers?: boolean;
}

export const ScoreDisplaySection: React.FC<ScoreDisplaySectionProps> = ({
	isLoading = false,
	isPrinting = false,
	maxScore,
	score,
	scoreSize,
	useAnimatedNumbers = false,
}) => {
	return (
		<div className={scoreDisplayStyles({ size: scoreSize })}>
			{isLoading ? (
				<SkeletonLoader className="h-16 w-20" />
			) : useAnimatedNumbers ? (
				<AnimatedScore isPrinting={isPrinting} maxScore={maxScore} score={score} />
			) : (
				<FormattedScore maxScore={maxScore} score={score} />
			)}
		</div>
	);
};

ScoreDisplaySection.displayName = 'ScoreDisplaySection';

export default ScoreDisplaySection;
